import axios from 'axios';
import { URLS } from '@constants/urls';
import api from '@helpers/api';
import { encodeQuery } from '@pentabd/ui';

export const getSettingsWiseReport = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async ({
    election_schedule_id,
    time_range,
  }: {
    election_schedule_id: number | string;
    time_range?: string;
  }): Promise<{ data: any }> => {
    if (isRequestInProcess) {
      source.cancel();
      source = cancelToken.source();
    }

    isRequestInProcess = true;

    return api
      .get(
        encodeQuery(URLS.GET_SETTINGS_WISE_REPORT, {
          election_schedule_id,
          ...(time_range && { time_range }),
        }),
      )
      .then((response) => {
        return { data: response.data };
      })
      .finally(() => {
        isRequestInProcess = false;
      });
  };
})();
